import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const Span = styled.div`
  color: ${props => props.theme.danger};
  margin: 0 60px -${props => props.height}px;
  line-height: ${props => props.height}px;
  font-size: 14px;
`;

const Error = ({ t, meta: { touched, error }, errorHeight = 50 }) =>
  touched && error ? <Span height={errorHeight}>{t(error)}</Span> : false;

export default translate()(Error);
